import { InjectionToken } from "@angular/core";
import { AutoBonusPeriodsPort } from "./auto-bonus-periods.port";

export const AUTO_BONUS_PERIODS_PORT =
  new InjectionToken<AutoBonusPeriodsPort>("AUTO_BONUS_PERIODS_PORT");
